import { render, staticRenderFns } from "./language-dialog.vue?vue&type=template&id=ab0f0732&"
import script from "./language-dialog.vue?vue&type=script&lang=js&"
export * from "./language-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports